import { z } from 'zod';

import { apiSchema } from '#api/model/types.ts';

export type ChargingDetails = z.infer<typeof apiSchema.ChargingDetails>;
export type ChargingConfiguration = ChargingDetails['configuration'];

export const chargingConfigurationSchema = apiSchema.ChargingConfiguration.superRefine((value, ctx) => {
    const valid =
        value.mode === 'target_percentage'
            ? value.target_percentage !== undefined && value.charging_duration_seconds === undefined
            : value.charging_duration_seconds !== undefined && value.target_percentage === undefined;
    if (!valid) {
        ctx.addIssue({ code: z.ZodIssueCode.custom, message: 'Invalid charging configuration' });
    }
});

export const withoutChargingEstimate = (charging?: ChargingDetails): ChargingDetails | undefined =>
    charging ? { configuration: charging.configuration, source: charging.source } : undefined;
